
const customDiamond = {
    draw(context, size) {
        // size は面積なので、一辺の長さを計算
        // (厳密な計算より、見た目のサイズ感を重視して調整することが多いです)
        const tan30 = Math.sqrt(3)
        const y = Math.sqrt(size / tan30)
        const x = y * tan30 / 2

        // 指定されたパス M4,1 L7,4 L4,7, L1,4 z の形状を
        // (0, 0) を中心とする相対座標に変換して描画
        // ここでは単純化のため、サイズ計算を簡易的な固定比率にします。

        const sqrtSize = Math.sqrt(size)
        const rx = sqrtSize * 0.72 // 横方向の半径
        const ry = sqrtSize * 0.72 // 縦方向の半径

        context.moveTo(0, -ry)    // 頂点上 (4, 1 に相当)
        context.lineTo(rx, 0)     // 頂点右 (7, 4 に相当)
        context.lineTo(0, ry)     // 頂点下 (4, 7 に相当)
        context.lineTo(-rx, 0)    // 頂点左 (1, 4 に相当)
        context.closePath()       // 閉じる (z)
    }
}

const customPentagon = {
    draw(context, size) {
        // size（面積）からスケール係数を算出
        // 標準的なd3.symbolに合わせて調整
        const s = Math.sqrt(size) / 5

        // 元の座標を (4, 4) を中心とした相対座標に変換し、sを掛ける
        // M4,1   -> (0, -3)
        // L7,4   -> (3, 0)
        // L5.5,7 -> (1.5, 3)
        // L2.5,7 -> (-1.5, 3)
        // L1,4   -> (-3, 0)

        context.moveTo(0, -3 * s)          // 頂点（上）
        context.lineTo(3 * s, 0)           // 右角
        context.lineTo(1.5 * s, 3 * s)         // 右下
        context.lineTo(-1.5 * s, 3 * s)        // 左下
        context.lineTo(-3 * s, 0)          // 左角
        context.closePath()                    // 閉じる (z)
    }
}

const customCross = {
    draw(context, size) {
        // size（面積）からスケール係数を算出
        const s = Math.sqrt(size) / 6

        // 元のパスの動きを (0,0) 中心になるようオフセット調整して再現
        // 開始点 M1, 2.5 を中心(4, 4)基準にすると (-3, -1.5)

        context.moveTo(-3   * s, -1.5 * s) // M1, 2.5
        context.lineTo(-2   * s, -2.5 * s) // l1, -1
        context.lineTo( 0, -0.5 * s) // l2, 2
        context.lineTo( 2   * s, -2.5 * s) // l2, -2
        context.lineTo( 3   * s, -1.5 * s) // l1, 1
        context.lineTo( 1,  0.5 * s) // l-2, 2
        context.lineTo( 3   * s,  2.5 * s) // l2, 2
        context.lineTo( 2   * s,  3.5 * s) // l-1, 1
        context.lineTo( 0,  1.5 * s) // l-2, -2
        context.lineTo(-2   * s,  3.5 * s) // l-2, 2
        context.lineTo(-3   * s,  2.5 * s) // l-1, -1
        context.lineTo(-1   * s,  0.5 * s) // l2, -2
        context.closePath()                // z
    }
}

const customTriangleUp = {
    draw(context, size) {
        const s = Math.sqrt(size) / 6

        // 中心を (4, 5) と仮定した相対座標
        // M4, 1 => ( 0, -4) * s
        // L1, 7 => (-3,  2) * s
        // L7, 7 => ( 3,  2) * s

        context.moveTo( 0, -4 * s)  // 上の頂点
        context.lineTo(-3 * s,  2 * s)  // 左下の角
        context.lineTo( 3 * s,  2 * s)  // 右下の角
        context.closePath()             // z
    }
}

const customTriangleLeft = {
    draw(context, size) {
        const s = Math.sqrt(size) / 6

        // 中心(4,4)からの相対座標
        // (1,4) -> (-3,  0)  // 左の頂点
        // (7,1) -> ( 3, -3)  // 右上の角
        // (7,7) -> ( 3,  3)  // 右下の角

        context.moveTo(-3 * s,  0) // 左の尖った先端
        context.lineTo( 3 * s, -3   * s) // 右上の角
        context.lineTo( 3 * s,  3   * s) // 右下の角
        context.closePath()
    }
}

const customTriangleRight = {
    draw(context, size) {
        // size（面積）からスケール係数を算出
        // 他の標準シンボルとサイズ感を合わせるため Math.sqrt(size) / 5 前後で調整
        const s = Math.sqrt(size) / 6

        // 中心を (4, 4) と仮定した相対座標
        // M7,4 => ( 3,  0) * s
        // L1,1 => (-3, -3) * s
        // L1,7 => (-3,  3) * s

        context.moveTo( 3 * s,  0)  // 右の頂点
        context.lineTo(-3 * s, -3 * s)  // 左上の角
        context.lineTo(-3 * s,  3 * s)  // 左下の角
        context.closePath()             // z（パスを閉じる）
    }
}

const customTriangleDown = {
    draw(context, size) {
        // size（面積）からスケール係数を算出
        const s = Math.sqrt(size) / 6

        // 中心を (4, 3) と仮定して相対座標に変換
        // M1,1 => (-3, -2) * s
        // L4,7 => ( 0,  4) * s
        // L7,1 => ( 3, -2) * s

        context.moveTo(-3 * s, -2 * s) // 左上の角
        context.lineTo( 0,  4 * s) // 下の頂点
        context.lineTo( 3 * s, -2 * s) // 右上の角
        context.closePath()            // z
    }
}

const customTriangleBottomLeft = {
    draw(context, size) {
        const s = Math.sqrt(size) / 6

        // 中心(4,4)からの相対座標
        // (1,1) -> (-3, -3) // 左上
        // (7,7) -> ( 3,  3) // 右下
        // (1,7) -> (-3,  3) // 左下

        context.moveTo(-3 * s, -3 * s) // 左上の頂点
        context.lineTo( 3 * s,  3 * s) // 右下の頂点
        context.lineTo(-3 * s,  3 * s) // 左下の角（直角部分）
        context.closePath()
    }
}

const customTriangleBottomRight = {
    draw(context, size) {
        const s = Math.sqrt(size) / 6

        // 中心(4,4)からの相対座標
        // (7,1) -> ( 3, -3) // 右上
        // (7,7) -> ( 3,  3) // 右下（直角）
        // (1,7) -> (-3,  3) // 左下

        context.moveTo( 3 * s, -3 * s) // 右上の頂点
        context.lineTo( 3 * s,  3 * s) // 右下の角（直角部分）
        context.lineTo(-3 * s,  3 * s) // 左下の頂点
        context.closePath()
    }
}



const customRect = {
    draw(context, size) {
        // size（面積）からスケール係数を算出
        const s = Math.sqrt(size) / 6

        // 中心を (4, 4) と仮定して相対座標に変換
        // M1, 5  => (-3,  1) * s
        // l6, 0  => 横に +6 移動 => ( 3,  1) * s
        // l0, -2 => 上に -2 移動 => ( 3, -1) * s
        // l-6, 0 => 横に -6 移動 => (-3, -1) * s
        // z      => 閉じる

        context.moveTo(-3 * s,  1) // 左下
        context.lineTo( 3 * s,  1) // 右下
        context.lineTo( 3 * s, -1 * s) // 右上
        context.lineTo(-3 * s, -1 * s) // 左上
        context.closePath()
    }
}
const customStar = {
    draw(context, size) {
        // size（面積）からスケール係数を算出
        const s = Math.sqrt(size) / 5

        // 中心を (4, 4) と仮定して相対座標に変換
        // 開始点 M4, 0.5 => (0, -3.5) * s

        context.moveTo( 0    , -3.5  * s) // 頂点（上）
        context.lineTo( 1.25 * s, -1.0  * s) // l1.25, 2.5
        context.lineTo( 3.5  * s, -0.5  * s) // l2.25, 0.5
        context.lineTo( 1.75 * s,  1.0  ) // l-1.75, 1.5
        context.lineTo( 2.0  * s,  3.5  * s) // l0.25, 2.5
        context.lineTo( 0       ,  2.25 * s) // l-2, -1.25
        context.lineTo(-2.0  * s,  3.5  * s) // l-2, 1.25
        context.lineTo(-1.75 * s,  1.5  * s) // l0.25, -2
        context.lineTo(-3.5  * s, -0.5  * s) // l-1.75, -2
        context.lineTo(-1.5  * s, -1.0  * s) // l2, -0.5
        context.closePath()                  // z
    }
}

const doubleCircle = {
    draw(context, size) {
        // sizeは面積なので、半径 r = sqrt(size / PI)
        const r = Math.sqrt(size / Math.PI)

        // 外側の円 (半径 r)
        // context.arc(x, y, radius, startAngle, endAngle)
        context.moveTo(r, 0)
        context.arc(0, 0, r, 0, 2 * Math.PI,false)

        const rInner = r * 0.99
        context.moveTo(rInner, 0)
        context.arc(0, 0, rInner, 0, 2 * Math.PI,true)

        context.moveTo(r * 0.4, 0)
        context.arc(0, 0, r * 0.4, 0, 2 * Math.PI,false)
    }
}

export default {
    diamond : customDiamond,
    pentagon : customPentagon,
    cross : customCross,
    triangleUp : customTriangleUp,
    triangleLeft : customTriangleLeft,
    triangleRight : customTriangleRight,
    triangleDown : customTriangleDown,
    triangleBottomLeft : customTriangleBottomLeft,
    triangleBottomRight : customTriangleBottomRight,
    rect : customRect,
    star : customStar,
    doubleCircle : doubleCircle
}
